import React from 'react';
import { Divider, Tooltip } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CustomMenu from '../../../../../components/Menu';
import CustomMenuItem from '../../../../../components/Menu/CustomMenuItem';
import MilestoneItem from './MilestoneItem';
import CreateEpic from './CreateEpic';
import MergeMilestone from '../../mergeMilestone/MergeMilestone';
import { TooltipName } from '../../../../../utils/Enums';
import { CustomButton } from '../../../../../components/Button/Button';

const DesktopEpicView = ({
  isTab,
  selectedMilestone,
  NoMilestone,
  anchorEl,
  open,
  handleClick,
  handleClose,
  showNoMile,
  noMileStoneSearch,
  handleNoMilestone,
  unCompletedMileStones,
  completedMileStones,
  epic,
  showEditArea,
  hoveredIndex,
  boardNameTitle,
  showEditButton,
  handleEditFieldClose,
  handleCheckboxChange,
  isAdmin,
  permissions,
  names,
  DarkIcon,
  apicIcon,
}) => {
  return (
    <>
      <Tooltip title={TooltipName.BOARD_PAGE.ALL_MILESTONE}>
        <CustomButton
          variant="outlined"
          color="primary"
          id="epics-board-dropdown"
          aria-controls={open ? "user-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          endIcon={<KeyboardArrowDownIcon sx={{ fontSize: 30, fill: "#1b3e62" }} />}
          className={
            isTab
              ? `milestone-drop-down-button ${
                  selectedMilestone === "" && NoMilestone !== "true"
                    ? "milestone-tab-border-none"
                    : "milestone-tab-border"
                } `
              : "white-button epics-btn"
          }
          sx={{
            height: "38px",
            padding: "5px 5px 5px 2px",
            border: "none",
            "&:hover": {
              outline: "none",
              border: "none" ,
              ...(selectedMilestone === "" && NoMilestone !== "true"
                ? ''
                : "milestone-tab-border-right"),
            },
          }}>
          <img
            src={isTab ? DarkIcon : apicIcon}
            className="header-filter-icon"
            alt="not found"
          />
        </CustomButton>
      </Tooltip>

      <CustomMenu
        id="user-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        className="epic-list">
        <div style={{ maxHeight: "222px", overflowY: "auto" }}>
          {showNoMile && (
            <>
              <CustomMenuItem className="menu-item-small" onClick={handleNoMilestone}>
                <div className="epic-name-id-div-noMilestone">
                  <p className={noMileStoneSearch === "true" ? "active-epic-name" : "epic-name"}>
                    Not Set
                  </p>
                </div>
              </CustomMenuItem>
              <Divider />
            </>
          )}

          {unCompletedMileStones?.map((item, index) => (
            <MilestoneItem
              key={`uncomplete-milestone-${item.epic_id}`}
              item={item}
              epic={epic}
              showEditArea={showEditArea}
              hoveredIndex={hoveredIndex}
              boardNameTitle={boardNameTitle}
              onMouseEnter={showEditButton}
              onMouseLeave={handleEditFieldClose}
              onClick={handleCheckboxChange}
            />
          ))}

          {permissions?.canCreateEpic && <CreateEpic />}

          {completedMileStones.length > 0 && (
            <div className="completed-epics mt-2">
              <p>Completed</p>
            </div>
          )}

          {completedMileStones?.map((item, index) => (
            <>
            <MilestoneItem
            key={`complete-milestone-${item.epic_id}`}
              item={item}
              epic={epic}
              showEditArea={showEditArea}
              hoveredIndex={hoveredIndex}
              boardNameTitle={boardNameTitle}
              onMouseEnter={showEditButton}
              onMouseLeave={handleEditFieldClose}
              onClick={handleCheckboxChange}
              showDivider={index < completedMileStones.length - 1}
            />
            {(completedMileStones.length == 1 || index == completedMileStones.length - 1) && <Divider />}
            </>
          ))}

          {permissions?.canMergeMilestone && names?.length > 0 && (
            <MergeMilestone milestones={names} />
          )}
        </div>
      </CustomMenu>
    </>
  );
};

export default DesktopEpicView; 
